import * as components from "../../components";
import {DeviceWarranty} from "./forms";
import React from "react";

export const DeviceWarrantyFormatter = function (cell:string, _row:any) {
  return (
    <components.Slider
      title={cell}
      header={
        <span>
          <span className="mr-3"> {components.ICONS.VIEW}</span><span className="pl3">Warranty Information for</span>{' '}
          <span className="ps-2">{cell}</span>{' '}
        </span>
      }
      buttonType="dropdown"
    >
      <DeviceWarranty device_identifier={cell} />
    </components.Slider>
  )
}
